import React, { useState } from 'react';
import './Login.css';
import { useHistory } from 'react-router-dom';
import backgroundImage from '../assets/img/678.png';
import { FaRegUserCircle } from "react-icons/fa";
import { RiLockPasswordLine } from "react-icons/ri";
import Loader from "../component/Loader";
import { getData, postData } from "../store/utils";
import Swal from "sweetalert2";

function LoginPage({ handleLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [enquiryData, setEnquiryData] = useState([]);
  const [isLoadingOn, setIsLoadingOn] = useState(false);
  const history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin(username, password, history);
  };

  const initialFormData = {
    shopOwnerName: "",
    shopName: "",
    registeredShopAddress: "",
    email: "",
    mobileNumber: "",
    anchorType: "Distributor",
    pincode: "",
    comment: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const handleSignUpSubmit = async (e) => {
    e.preventDefault();
    if (formData) {
      let filterData = {
        shopOwnerName: formData.shopOwnerName,
        shopName: formData.shopName,
        registeredShopAddress: formData.registeredShopAddress,
        email: formData.email,
        mobileNumber: formData.mobileNumber,
        anchorType: formData.anchorType,
        pincode: formData.pincode,
        comment: formData.comment,
      };
      setIsLoadingOn(true);
      const tempData = await postData(`enquiry/anchorEnquiry`, filterData);
      setIsLoadingOn(false);
      console.log("tempData == ", tempData);
      setShowModal(false);
      if (tempData.statusCode == 200) {
        setEnquiryData(tempData.data);
        setFormData(initialFormData);
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: tempData.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Something went wrong!",
        });
      }
    }
  };

  console.log("formData == ", formData);
  
  return (
    <div className='loginBodyPage'>
      {isLoadingOn ? <Loader /> : ""}
      <div className="LoginPageContainer">
        <div className="LoginPageInnerContainer">
          <div className="ImageContianer">
            <img src={backgroundImage} className="GroupImage" />
          </div>
          <div className="LoginFormContainer">
            <div className="LoginFormInnerContainer">
              <div className="LogoContainer">
                {/* <img
                  src="https://www.pngkey.com/png/full/529-5291672_sample-logo-png-transparent-background.png"
                  className="logo"
                /> */}
                <div className="logo">
                <img src="../assets/img/Daqi_logo.png" className='logo' />
                  <h1
                    style={{
                      color: "#2e1f7a",
                      fontWeight: "bold",
                      marginBottom: 30,
                      fontSize: "30px",
                      marginLeft: 20,
                    }}
                  >
                    DAQI
                  </h1>
                </div>
               
              </div>
              <header className="header">Log in</header>
              <header className="subHeader">
                Welcome to <b>DAQI</b> Please Enter Login Details.
              </header>
              <form onSubmit={handleSubmit}>
                <div className="inputContainer">
                  <label className="label" htmlFor="emailAddress">
                  <FaRegUserCircle />{' '}
                    <span>&nbsp;Email Address*</span>
                  </label>
                  <input type="text" placeholder="Enter your Email Address" required=""
                    value={username} className="input"
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
                <div className="inputContainer">
                  <label className="label" htmlFor="emailAddress">
                  <RiLockPasswordLine />
                    <span>&nbsp;Password*</span>
                  </label>
                  <input type="password" placeholder="Enter your Password" required=""
                    value={password} className="input"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                {/* <div className="OptionsContainer">
                  <div className="checkboxContainer">
                    <input type="checkbox" id="RememberMe" className="checkbox" />{" "}
                    <label htmlFor="RememberMe">Remember me</label>
                  </div>
                  <a href="#" className="ForgotPasswordLink">
                    Forgot Password?
                  </a>
                </div> */}
                <div className="loginActions">
                  <button className="LoginButton" type="submit">Login</button>
                  <span className="signupText">
                    New User? <a className="signUpLink" onClick={() => setShowModal(true)}>Sign up</a>
                  </span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Sign Up Modal */}
      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <span className="close-button" onClick={() => setShowModal(false)}>&times;</span>
            <h4>Sign Up</h4>
            <form onSubmit={handleSignUpSubmit}>
              <input type="text" placeholder="Shop Owner Name" required value={formData.shopOwnerName} onChange={(e) => setFormData({ ...formData, shopOwnerName: e.target.value })} />
              <input type="text" placeholder="Shop Name" required value={formData.shopName} onChange={(e) => setFormData({ ...formData, shopName: e.target.value })} />
              <input type="email" placeholder="Email" required value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
              <input type="text" placeholder="Mobile Number" required value={formData.mobileNumber} onChange={(e) => {const value = e.target.value.replace(/\D/g, ""); if (value.length <= 10) {setFormData({ ...formData, mobileNumber: value })} }} />
              <input type="text" placeholder="Registered Shop Address" required value={formData.registeredShopAddress} onChange={(e) => setFormData({ ...formData, registeredShopAddress: e.target.value })} />
              <input type="text"  placeholder="Pincode" required  value={formData.pincode}  onChange={(e) => { const value = e.target.value.replace(/\D/g, ""); if (value.length <= 6) { setFormData({ ...formData, pincode: value })} }}/>
              <select value={formData.anchorType} onChange={(e) => setFormData({ ...formData, anchorType: e.target.value })}>
                <option value="Distributor">Distributor</option>
                <option value="Manufacturer">Manufacturer</option>
                <option value="Retailer">Retailer</option>
              </select>
              <textarea placeholder="Comment" value={formData.comment} onChange={(e) => setFormData({ ...formData, comment: e.target.value })}></textarea>
              <div className="button-container">
                <button type="submit" className="submit-button">Submit</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>

  );
}

export default LoginPage;